import * as React from "react";
import { Flex, Text, Button } from "@radix-ui/themes";
import * as RadixHoverCard from "@radix-ui/react-hover-card";
import { radixThemeDataAttributes } from "@/components/Theme";

interface HoverCardProps {
  trigger: React.ReactNode;
  title: string;
  description: string;
  titleWeight?: "medium" | "bold" | "regular";
  buttonText?: string;
  onButtonClick?: () => void;
  buttonVariant?: "solid" | "outline" | "ghost";
  buttonColor?: "gray" | "blue" | "green" | "red" | "yellow";
  buttonHighContrast?: boolean;
  openDelay?: number;
  closeDelay?: number;
}

export function HoverCard({
  trigger,
  title,
  description,
  titleWeight = "medium",
  buttonText,
  onButtonClick,
  buttonVariant = "solid",
  buttonColor = "gray",
  buttonHighContrast = false,
  openDelay = 50,
  closeDelay = 0,
}: HoverCardProps) {
  return (
    <RadixHoverCard.Root openDelay={openDelay} closeDelay={closeDelay}>
      <RadixHoverCard.Trigger asChild>{trigger}</RadixHoverCard.Trigger>
      <RadixHoverCard.Portal>
        <RadixHoverCard.Content
          className="radix-themes z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2"
          {...radixThemeDataAttributes}
          sideOffset={4}
        >
          <Flex direction="column" gap="2">
            <Text size="2" color="gray" highContrast weight={titleWeight}>
              {title}
            </Text>
            
            <Text size="2" color="gray">
              {description}
            </Text>

            {buttonText && onButtonClick && (
              <Button
                size="1"
                variant={buttonVariant}
                color={buttonColor}
                highContrast={buttonHighContrast}
                onClick={onButtonClick}
                style={{ marginTop: "4px" }}
              >
                {buttonText}
              </Button>
            )}
          </Flex>
        </RadixHoverCard.Content>
      </RadixHoverCard.Portal>
    </RadixHoverCard.Root>
  );
}
